"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    Object.defineProperty(o, k2, { enumerable: true, get: function() { return m[k]; } });
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
exports.__esModule = true;
var react_1 = __importDefault(require("react"));
var react_router_dom_1 = require("react-router-dom");
var form_simple_1 = __importDefault(require("../../../../simple-ui/form-simple"));
var Data = __importStar(require("../../../interface/email/data"));
var initialData = {
    content: '',
    isHtml: true,
    recipient: '',
    title: ''
};
var SendEmail = function (_a) {
    var url = _a.url, withBackend = _a.withBackend;
    var history = react_router_dom_1.useHistory();
    var handleCancel = function () {
        history.push(url);
    };
    var fields = [
        {
            label: 'Title',
            name: 'title',
            type: 'string'
        },
        {
            label: 'Recipient',
            name: 'recipient',
            type: 'string'
        },
        {
            label: 'Is HTML?',
            name: 'isHtml',
            type: 'boolean'
        },
        {
            label: 'Content',
            name: 'content',
            type: 'string',
            ux: 'textarea',
            inputProps: {
                rows: 3,
                rowsMax: 10
            }
        }
    ];
    return (react_1["default"].createElement(form_simple_1["default"], { data: initialData, fields: fields, promise: function (data) { return Data.sendEmail(data, withBackend); }, onCancel: handleCancel }));
};
exports["default"] = SendEmail;
